import { useEnvironment } from '@wix/yoshi-flow-editor';
import React from 'react';
import {
  Avatar,
  AvatarSize,
  Button,
  ButtonSize,
  HoverStyles,
  PaddingModes,
  Text,
  ThumbnailImage,
} from 'wix-ui-tpa/cssVars';
import { DiscountName } from '../../DiscountName/DiscountName';
import { AgendaItemLayoutProps } from '../const';
import { classes, st } from './AgendaItemList.st.css';

export const AgendaItemListLayout: React.FC<AgendaItemLayoutProps> = ({
  agendaItemViewModel,
  onSlotClick,
}) => {
  const {
    serviceName,
    serviceImage,
    startTime,
    duration,
    staffName,
    staffImage,
    location,
    spots,
    price,
    priceBeforeDiscount,
    priceAfterDiscount,
    discountName,
    showCalculatedAtCheckout,
    buttonText,
    disabled,
    slotId,
  } = agendaItemViewModel || {};
  const { isMobile } = useEnvironment();

  return (
    <div
      className={st(classes.root, {
        isMobile,
      })}
    >
      <ThumbnailImage {...serviceImage} className={classes.serviceImage} />

      <div className={st(classes.content)}>
        <div className={st(classes.topWrapper)}>
          <div className={st(classes.nameAndDurationWrapper)}>
            <Text className={classes.serviceName}>{serviceName}</Text>
            <Text className={classes.startTime}>
              {startTime}
              <Text className={classes.duration}>({duration})</Text>
            </Text>
          </div>
          <div className={st(classes.staffAndLocationWrapper)}>
            <div className={classes.staff}>
              <Avatar
                className={classes.staffImage}
                size={AvatarSize.small}
                src={staffImage}
                name={staffName}
              />
              <Text className={classes.staffName}>{`${staffName}`}</Text>
            </div>
            <Text className={classes.location}>{location}</Text>
          </div>
        </div>
        <div className={st(classes.bottomWrapper)}>
          <div className={st(classes.priceAndSpotsWrapper)}>
            <div className={classes.priceContainer}>
              {priceBeforeDiscount && priceAfterDiscount ? (
                <div className={classes.pricesRow}>
                  <Text
                    className={classes.priceBeforeDiscount}
                    data-hook="agenda-item-price-before-discount"
                  >
                    {priceBeforeDiscount}
                  </Text>
                  <Text className={classes.price}>{priceAfterDiscount}</Text>
                </div>
              ) : (
                <Text className={classes.price}>{price}</Text>
              )}
              <DiscountName
                discountName={discountName}
                showCalculatedAtCheckout={showCalculatedAtCheckout}
              />
            </div>
            <Text className={classes.spots}>{spots}</Text>
          </div>
          <div className={st(classes.buttonWrapper)}>
            <Button
              onClick={() => onSlotClick(slotId)}
              disabled={disabled}
              className={classes.button}
              size={ButtonSize.small}
              paddingMode={PaddingModes.explicitPaddings}
              hoverStyle={HoverStyles.underline}
            >
              {buttonText}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
